import { createSlice } from '@reduxjs/toolkit';
export const voicemailSlice = createSlice({
    name: 'voicemail',
    initialState: {
        loading: true,
        newVoicemail: [],
        savedVoicemail: [],
        error: null,
    },
    reducers: {

        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setNewVoicemail: (state, action) => {
            state.newVoicemail = action.payload;
        },
        setSavedVoicemail: (state, action) => {
            state.savedVoicemail = action.payload;
        }
    },
});

export const { setLoading, setNewVoicemail, setSavedVoicemail } = voicemailSlice.actions;

//Selectors
export const selectVoicemail = (state) => state.voicemail;
export const selectNewVoicemail = (state) => state.voicemail.newVoicemail;
export const selectSavedVoicemail = (state) => state.voicemail.savedVoicemail;
export default voicemailSlice.reducer;